import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var WebDesign = function WebDesign(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$secondaryColor = _ref.secondaryColor,
    secondaryColorProp = _ref$secondaryColor === void 0 ? '#6F4EF6' : _ref$secondaryColor,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  var secondaryColor = !ignoreColor ? secondaryColorProp : undefined;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M40 44H6C4.35 44 3 42.65 3 41V7C3 5.35 4.35 4 6 4H40C41.65 4 43 5.35 43 7V22.1H41V7C41 6.45 40.55 6 40 6H6C5.45 6 5 6.45 5 7V41C5 41.55 5.45 42 6 42H40C40.55 42 41 41.55 41 41V31.9H43V41C43 42.65 41.65 44 40 44Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M42 12H4V14H42V12Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M38 8H36V10H38V8Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M33 8H31V10H33V8Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M28 8H26V10H28V8Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M41 33H22.7L13.4375 27L22.7 21H41C44.3125 21 47 23.6875 47 27C47 30.3125 44.3125 33 41 33ZM23.3 31H41C43.2 31 45 29.2 45 27C45 24.8 43.2 23 41 23H23.3L17.125 27L23.3 31Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M41 22H39V32H41V22Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M24 22H22V32H24V22Z",
      fill: secondaryColor
    })]
  });
};
export default WebDesign;